import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'

Vue.use(Router)

// const importPageChunk = (path) => import(/* webpackChunkName: "pages" */ path)
const LoginPage = () => import(/* webpackChunkName: "pages" */ '@/pages/LoginPage')
const ConsentsPage = () => import(/* webpackChunkName: "pages" */ '@/pages/ConsentsPage')
const ConsentDetailsPage = () => import(/* webpackChunkName: "pages" */ '@/pages/ConsentDetailsPage')
const NotFoundPage = () => import(/* webpackChunkName: "pages" */ '@/pages/NotFoundPage')
const MagicLinkPage = () => import(/* webpackChunkName: "pages" */ '@/pages/MagicLinkPage')
const LogoutPage = () => import(/* webpackChunkName: "pages" */ '@/pages/LogoutPage')
const DriverProfilePage = () => import(/* webpackChunkName: "pages" */ '@/pages/DriverProfilePage')

const routeAuthGuard = (redirectRoute, loggedRoute = undefined, withReturnUrl = false) =>
  (to, from, next) => {
    const _redirectRoute = withReturnUrl ? `${redirectRoute}?return=${to.fullPath}` : redirectRoute
    const nextRoute = store.getters.isLoggedIn ? loggedRoute : _redirectRoute

    console.log('routeAuthGuard sending to ', nextRoute)
    next(nextRoute)
  }

const router = new Router({

  routes: [
    {
      path: '/login',
      name: 'login',
      component: LoginPage,
      beforeEnter: routeAuthGuard(undefined, '/')
    },
    {
      path: '/magic',
      name: 'magic-link',
      component: MagicLinkPage
    },
    {
      path: '/logout',
      name: 'logout',
      component: LogoutPage,
      beforeEnter: routeAuthGuard('/login')
    },
    {
      path: '/',
      alias: '/consents',
      name: 'consents',
      component: ConsentsPage,
      beforeEnter: routeAuthGuard('/login')
    },
    {
      path: '/consents/:id',
      name: 'consent-details',
      component: ConsentDetailsPage,
      props: true,
      beforeEnter: routeAuthGuard('/login', undefined, true)
    },
    {
      path: '/profile',
      name: 'driver-profile',
      component: DriverProfilePage,
      beforeEnter: routeAuthGuard('/login')
    },
    {
      path: '*',
      component: NotFoundPage
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js